import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class AdvocateEffects {




  constructor(private actions$: Actions) {}

}
